<template>
	<div class="list">
		<van-list
			:loading="value"
			:finished="moreFinished"
			:error="moreError"
			:offset="moreOffset"
			:loadingText="moreLoadingText"
			:finishedText="moreFinishedText"
			:errorText="moreErrorText"
			:immediateCheck="moreImmediateCheck"
			:direction="moreDirection"
			@load="moreLoad"
		>
			<template #loading>
				<slot name="loading"></slot>
			</template>
			<template #finished>
				<slot name="finished"></slot>
			</template>
			<template #error>
				<slot name="error"></slot>
			</template>
			<slot name="default"></slot>
		</van-list>
	</div>
</template>

<script>
export default {
	name: 'list',
	model: {
		prop: 'value',
		event: 'change'
	},
	props: {
		value: {
			// 是否处于加载状态，加载过程中不触发load事件
			type: Boolean,
			default: false
		},
		moreFinished: {
			// 是否已加载完成，加载完成后不再触发load事件
			type: Boolean,
			default: false
		},
		moreError: {
			// 是否加载失败，加载失败后点击错误提示可以重新触发load事件，必须使用sync修饰符
			type: Boolean,
			default: false
		},
		moreOffset: {
			// 滚动条与底部距离小于 offset 时触发load事件
			type: [Number, String],
			default: 300
		},
		moreLoadingText: {
			// 加载过程中的提示文案
			type: String,
			default: '加载中...'
		},
		moreFinishedText: {
			// 加载完成后的提示文案
			type: String,
			default: '1'
		},
		moreErrorText: {
			// 加载失败后的提示文案
			type: String,
			default: '2'
		},
		moreImmediateCheck: {
			// List初始化后是否触发一次load事件，用于加载第一屏的数据
			type: Boolean,
			default: true
		},
		moreDirection: {
			// 滚动触发加载的方向，可选值为up
			type: String,
			default: 'down'
		}
	},
	watch: {},
	computed: {},
	data() {
		return {}
	},
	methods: {
		moreLoad() {
			// 滚动条与底部距离小于 offset 时触发
			this.$emit('change', true)
			this.$emit('moreLoad')
		}
	}
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus"></style>
